module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hans_kyushu-5102be5837bebd365edd6b790722e9b3.jpg";